module.exports = __webpack_public_path__ + "img/card_250020784.dead9761.jpg";